"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("../Box"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var LogTextMessage = function LogTextMessage(_ref) {
  var action = _ref.action,
    user = _ref.user,
    description = _ref.description,
    error = _ref.error;
  var actionMemo = (0, _react.useMemo)(function () {
    if (typeof action === 'string') {
      return action.charAt(0).toUpperCase() + action.slice(1);
    }
    return action;
  }, [action]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography["default"], {
      "data-cy": 'log-text',
      children: [actionMemo ? actionMemo : '', ' ', action && user ? 'by' : '', " ", user ? user : '']
    }), description && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box["default"], {
      "data-cy": 'log-description',
      color: error ? 'error.main' : 'inherit',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
        children: description
      })
    })]
  });
};
var _default = exports["default"] = LogTextMessage;